/**
 * Tappeer Avatar variant "E"
 *
 * Used when extraction is complete / success states.
 * Based on libs/ui-toolkit/src/assets/images/tappeer_avatar_e.svg
 */
export function TappeerAvatarE({ className = '' }: { className?: string }) {
  return (
    <svg
      width='220'
      height='220'
      viewBox='0 0 220 220'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden='true'
    >
      <rect width='220' height='220' fill='white' />
      <path
        d='M110.255 184.556C89.2068 184.556 71.8841 177.664 58.2867 163.88C44.6893 149.91 37.8906 132.215 37.8906 110.794C37.8906 89.0019 44.5031 71.2135 57.7279 57.4299C71.139 43.6462 88.3686 36.7544 109.417 36.7544C131.396 36.7544 148.719 43.4599 161.385 56.8711C174.237 70.2822 180.663 88.3499 180.663 111.074V121.97H158.032C158.032 121.97 160.272 115.456 153.028 109.37C148.507 105.572 141.245 100.285 131.489 100.285C121.733 100.285 115.568 107.062 105.364 111.406C95.1627 115.751 79.203 111.406 79.203 111.406C81.6244 129.473 92.2802 149.631 111.093 149.631C119.289 149.631 126.087 148.234 131.489 145.44C136.891 142.646 140.337 138.734 141.827 133.705H181.222C178.614 149.165 170.884 161.552 158.032 170.865C145.366 179.992 129.44 184.556 110.255 184.556Z'
        fill='black'
      />
      <path
        d='M88.2189 49.2438L80.3457 58.4342C80.3457 58.4342 66.5257 54.5405 65.2332 49.7615C63.9384 44.9822 65.7511 39.7999 68.6882 37.5627C71.623 35.3254 74.3489 35.0924 77.972 35.7995C81.5928 36.5069 88.2189 49.2438 88.2189 49.2438Z'
        fill='#474747'
      />
      <path
        d='M116.41 84.393C117.937 83.1277 118.893 82.0419 119.066 80.0664C119.238 78.091 118.484 76.8553 117.201 75.3448C115.915 73.8342 113.559 72.7929 111.742 72.5887C109.927 72.3843 108.742 72.4808 107.12 73.3242C105.498 74.1676 103.34 76.7025 103.233 78.6823C103.129 80.6622 103.815 81.8943 105.1 83.4048C106.384 84.9154 108.178 85.9512 110.556 86.1602C112.935 86.3669 114.882 85.6582 116.41 84.393Z'
        fill='#F39EE5'
      />
      <path
        d='M135.404 64.2582C135.492 58.6134 130.988 53.9659 125.343 53.8775C119.698 53.7891 115.051 58.2936 114.962 63.9381C114.874 69.5829 119.378 74.2304 125.023 74.3188C130.668 74.4071 135.315 69.9029 135.404 64.2582Z'
        fill='white'
      />
      <path
        d='M134.251 65.376C134.319 60.9858 130.817 57.3709 126.426 57.3023C122.035 57.2334 118.421 60.7368 118.353 65.1272C118.282 69.5174 121.787 73.1323 126.176 73.2009C130.567 73.2698 134.181 69.7664 134.251 65.376Z'
        fill='black'
      />
    </svg>
  );
}
